import React, {FC, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {companyPath} from '../PublicModels'
import {PublicLoading, PublicNotFound} from '../components/PublicState'
import {ApplyForm} from './ApplyForm'
import {PublicJobLayout} from './PublicJobLayout'
import {usePublicJob} from './usePublicJob'

/** Başvuru ekranı (/jobs/:id/apply): solda ilan bilgileri, sağda başvuru formu */
const PublicJobApplyPage: FC = () => {
  const {id} = useParams<{id: string}>()
  const {job, company, state} = usePublicJob(id)
  const [submitted, setSubmitted] = useState(false)

  if (state === 'loading') return <PublicLoading />
  if (state === 'notFound' || !job || !company) {
    return (
      <PublicNotFound
        title='İlan bulunamadı'
        description='Bu ilan yayından kaldırılmış ya da bağlantı hatalı olabilir.'
      />
    )
  }

  return (
    <PublicJobLayout
      job={job}
      company={company}
      aside={
        submitted ? (
          <div className='pc-aside text-center'>
            <i className='bi bi-check-circle-fill text-success d-block mb-5' style={{fontSize: 56}}></i>
            <div className='pc-aside-title'>Başvurunuz alındı</div>
            <div className='pc-aside-text'>
              {company.name} ekibi başvurunuzu inceleyip sizinle iletişime geçecektir. İlginiz için teşekkür ederiz.
            </div>
            {company.slug && (
              <Link to={companyPath(company.slug)} className='pc-btn-secondary'>
                Diğer Pozisyonları Gör
              </Link>
            )}
          </div>
        ) : (
          <ApplyForm
            job={job}
            company={company}
            onSuccess={() => {
              setSubmitted(true)
              window.scrollTo({top: 0, behavior: 'smooth'})
            }}
          />
        )
      }
    />
  )
}

export {PublicJobApplyPage}
